import React, { useEffect, useRef, useCallback } from "react";

const TacticalCursor = () => {
  const canvasRef = useRef(null);
  const mouse = useRef({ x: -100, y: -100 });
  const pos = useRef({ x: -100, y: -100 });
  const raf = useRef(null);

  const onMove = useCallback((e) => { mouse.current = { x: e.clientX, y: e.clientY }; }, []);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    const resize = () => { c.width = window.innerWidth; c.height = window.innerHeight; };
    resize();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMove);

    const draw = () => {
      ctx.clearRect(0, 0, c.width, c.height);
      pos.current.x += (mouse.current.x - pos.current.x) * 0.3; // Snappier follow
      pos.current.y += (mouse.current.y - pos.current.y) * 0.3;
      const { x, y } = pos.current;

      // Outer targeting box
      const s = 12; // size
      ctx.beginPath();
      // Top Left
      ctx.moveTo(x - s, y - s + 4); ctx.lineTo(x - s, y - s); ctx.lineTo(x - s + 4, y - s);
      // Top Right
      ctx.moveTo(x + s - 4, y - s); ctx.lineTo(x + s, y - s); ctx.lineTo(x + s, y - s + 4);
      // Bottom Right
      ctx.moveTo(x + s, y + s - 4); ctx.lineTo(x + s, y + s); ctx.lineTo(x + s - 4, y + s);
      // Bottom Left
      ctx.moveTo(x - s + 4, y + s); ctx.lineTo(x - s, y + s); ctx.lineTo(x - s, y + s - 4);
      
      ctx.strokeStyle = "rgba(0, 240, 255, 0.6)";
      ctx.lineWidth = 1;
      ctx.stroke();

      // Center dot
      ctx.beginPath();
      ctx.arc(x, y, 1.5, 0, Math.PI * 2);
      ctx.fillStyle = "#00f0ff";
      ctx.fill();

      // Scanning line
      ctx.beginPath();
      ctx.moveTo(x - s - 2, y); ctx.lineTo(x + s + 2, y);
      ctx.strokeStyle = "rgba(0, 240, 255, 0.2)";
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(x, y - s - 2); ctx.lineTo(x, y + s + 2);
      ctx.stroke();

      raf.current = requestAnimationFrame(draw);
    };
    raf.current = requestAnimationFrame(draw);
    return () => {
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf.current);
    };
  }, [onMove]);

  return <canvas ref={canvasRef} style={{ position: "fixed", inset: 0, zIndex: 99999, pointerEvents: "none" }} />;
};

export default TacticalCursor;
